export class Orgfile {
    filename:string;
    uploaddate:Date;
    uploadeby:string;
    stageId?:string;
    taskId?:string;
    taskInputName?:string;
    infoboxId?:string;
    filetype:string;
    projectId:string;
    customerId:string;
    fileId:string;
    organizationId:string;
    fileurl:string;
    visibility:string;
}